/*
 * Copyright 2026 North Carolina State University
 */

import React, { useState } from 'react';
import '../../styles/ManageProgramData.css';
import UserManagement from './UserManagement';
import DepartmentManagement from './DepartmentManagement';
import FacilityManagement from './FacilityManagement';
import ChamberManagement from './ChamberManagement';
import SubstrateManagement from './SubstrateManagement';
import SpeciesManagement from './SpeciesManagement';
import LightingManagement from './LightingManagement';
import PotManagement from './PotManagement';
import UnitManagement from './UnitManagement';
import ResourceManagement from './ResourceManagement';
import WaterManagement from './WaterManagement';
import ProjectRoleManagement from './ProjectRoleManagement';
import InstitutionRoleManagement from './InstitutionRoleManagement';
import InvoiceTemplateManagement from './InvoiceTemplateManagement';
import EmailServiceManagement from './EmailServiceManagement';
import BrandingManagement from './BrandingManagement';

const ManageProgramData = () => {
  const [activeSection, setActiveSection] = useState('users');

  const renderSection = () => {
    switch (activeSection) {
      case 'users': return <UserManagement />;
      case 'departments': return <DepartmentManagement />;
      case 'facilities': return <FacilityManagement />;
      case 'chambers': return <ChamberManagement />;
      case 'substrates': return <SubstrateManagement />;
      case 'species': return <SpeciesManagement />;
      case 'lighting': return <LightingManagement />;
      case 'pots': return <PotManagement />;
      case 'units': return <UnitManagement />;
      case 'resources': return <ResourceManagement />;
      case 'water': return <WaterManagement />;
      case 'project-roles': return <ProjectRoleManagement />;
      case 'institution-roles': return <InstitutionRoleManagement />;
      case 'invoice-template': return <InvoiceTemplateManagement />;
      case 'email-service': return <EmailServiceManagement />;
      case 'branding': return <BrandingManagement />;
      default: return <UserManagement />;
    }
  };

  return (
    <div className="manage-program-container">
      <div className="sidebar">
        <h2>Program Data</h2>
        <ul>
          <li>
            <button
              type="button"
              className={activeSection === 'users' ? 'active' : ''}
              aria-current={activeSection === 'users' ? 'page' : undefined}
              onClick={() => setActiveSection('users')}
            >Users</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'departments' ? 'active' : ''}
              aria-current={activeSection === 'departments' ? 'page' : undefined}
              onClick={() => setActiveSection('departments')}
            >Departments</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'facilities' ? 'active' : ''}
              aria-current={activeSection === 'facilities' ? 'page' : undefined}
              onClick={() => setActiveSection('facilities')}
            >Facilities</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'chambers' ? 'active' : ''}
              aria-current={activeSection === 'chambers' ? 'page' : undefined}
              onClick={() => setActiveSection('chambers')}
            >Compartments</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'substrates' ? 'active' : ''}
              aria-current={activeSection === 'substrates' ? 'page' : undefined}
              onClick={() => setActiveSection('substrates')}
            >Substrates</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'species' ? 'active' : ''}
              aria-current={activeSection === 'species' ? 'page' : undefined}
              onClick={() => setActiveSection('species')}
            >Species</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'lighting' ? 'active' : ''}
              aria-current={activeSection === 'lighting' ? 'page' : undefined}
              onClick={() => setActiveSection('lighting')}
            >Lighting</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'pots' ? 'active' : ''}
              aria-current={activeSection === 'pots' ? 'page' : undefined}
              onClick={() => setActiveSection('pots')}
            >Pots</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'units' ? 'active' : ''}
              aria-current={activeSection === 'units' ? 'page' : undefined}
              onClick={() => setActiveSection('units')}
            >Units</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'resources' ? 'active' : ''}
              aria-current={activeSection === 'resources' ? 'page' : undefined}
              onClick={() => setActiveSection('resources')}
            >Resources</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'water' ? 'active' : ''}
              aria-current={activeSection === 'water' ? 'page' : undefined}
              onClick={() => setActiveSection('water')}
            >Water</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'project-roles' ? 'active' : ''}
              aria-current={activeSection === 'project-roles' ? 'page' : undefined}
              onClick={() => setActiveSection('project-roles')}
            >Project Roles</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'institution-roles' ? 'active' : ''}
              aria-current={activeSection === 'institution-roles' ? 'page' : undefined}
              onClick={() => setActiveSection('institution-roles')}
            >Institution Roles</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'invoice-template' ? 'active' : ''}
              aria-current={activeSection === 'invoice-template' ? 'page' : undefined}
              onClick={() => setActiveSection('invoice-template')}
            >Invoice Template</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'email-service' ? 'active' : ''}
              aria-current={activeSection === 'email-service' ? 'page' : undefined}
              onClick={() => setActiveSection('email-service')}
            >Email Service</button>
          </li>
          <li>
            <button
              type="button"
              className={activeSection === 'branding' ? 'active' : ''}
              aria-current={activeSection === 'branding' ? 'page' : undefined}
              onClick={() => setActiveSection('branding')}
            >Branding</button>
          </li>
        </ul>
      </div>
      <div className="content-area">
        {renderSection()}
      </div>
    </div>
  );
};

export default ManageProgramData;
